import {useUserInfo} from "@/composables/useUserInfo";
import {NavigationGuardNext, RouteLocationNormalized} from "vue-router";

const routes = [
    {
        path: '/',
        name: 'loading',
        meta: {
            layout: "default"
        },
        redirect: {name: 'schedule'}
    },
    {
        path: '/callback',
        name: 'callback',
        component: async () => import('@/layout/LayoutEmpty.vue'),
        meta: {
            layout: "default",
            public: true
        },
    },
    {
        path: '/reauthenticate',
        name: 'reauthenticate',
        component: async () => import('@/layout/LayoutEmpty.vue'),
        meta: {
            layout: "no-header",
            public: false
        },
    },
    {
        path: '/agenda',
        name: 'schedule',
        beforeEnter: (
            to: RouteLocationNormalized,
            from: RouteLocationNormalized,
            next: NavigationGuardNext
        ) => {
            const { isLegacyTheme } = useUserInfo();
            if (isLegacyTheme(to.name)) {
                to.matched[0].components = { default: () => import('@/views/Agenda/Agenda.vue') };
            } else {
                to.matched[0].components = { default: () => import('@/modern/views/Agenda/HomeView.vue') };
            }
            next();
        },
        meta: {
            title: "Agenda",
        },
    },
    {
        path: '/tutorial',
        name: 'tutorial',
        component: () => import('@/components/Tutorial/TutorialStepper.vue'),
        meta: {layout: "no-header"},
    },
    {
        path: '/ajuda',
        name: 'help',
        component: () => import('@/views/Ajuda/Ajuda.vue'),
        meta: {
            title: 'Ajuda'
        }
    },
    {
        path: '/relato',
        name: 'report-problem',
        component: () => import('@/components/ReportProblem/ReportProblem.vue'),
        meta: {
            title: 'Relatar um problema'
        }
    },
    {
        path: '/agenda/detalhes/:id',
        name: 'schedule-details',
        beforeEnter: (
            to: RouteLocationNormalized,
            from: RouteLocationNormalized,
            next: NavigationGuardNext
        ) => {
            const { isLegacyTheme } = useUserInfo();
            if (isLegacyTheme(to.name)) {
                to.matched[0].components = { default: () => import('@/views/Agenda/Detalhes.vue') };
            } else {
                if(to.name?.toString().includes('.subscribers')) {
                    to.matched[0].components = { default: () => import('@/modern/views/Agenda/InscritosView.vue') };
                } else {
                    to.matched[0].components = {default: () => import('@/modern/views/Agenda/DetalhesView.vue')};
                }
            }
            next();
        },
        meta: {
            title: "Detalhes do encontro ",
        },
        children: [
            {
                path: 'inscritos',
                name: 'schedule-details.subscribers',
                component: () => import('@/modern/views/Agenda/InscritosView.vue'),
            },
            {
                path: 'modal/justificativa',
                name: 'schedule-details.justification',
                components: {
                    modal: () => import('@/modern/views/Agenda/detalhes/modais/JustificativaModal.vue'),
                }
            },
            {
                path: 'modal/observacao',
                name: 'schedule-details.observation',
                components: {
                    modal: () => import('@/modern/views/Agenda/detalhes/modais/ObservacaoModal.vue'),
                }
            },
        ]
    },
    {
        path: '/registrar/:id',
        name: 'register-meeting',
        beforeEnter: (
            to: RouteLocationNormalized,
            from: RouteLocationNormalized,
            next: NavigationGuardNext
        ) => {
            const { isLegacyTheme } = useUserInfo();
            if (isLegacyTheme(to.name)) {
                to.matched[0].components = { default: () => import('@/views/Registrar/Registrar.vue') };
            } else {
                to.matched[0].components = {default: () => import('@/modern/views/Agenda/RegistroView.vue')};
            }
            next();
        },
        children: [
            {
                path: 'modal/conteudos',
                name: 'register-meeting.contents',
                components: {
                    modal: () => import('@/modern/views/Agenda/modais/ConteudosModal.vue'),
                }
            },
            {
                path: 'modal/justificativa',
                name: 'register-meeting.justification',
                components: {
                    modal: () => import('@/modern/views/Agenda/modais/JustificativaModal.vue'),
                }
            },
            {
                path: 'modal/observacao',
                name: 'register-meeting.observation',
                components: {
                    modal: () => import('@/modern/views/Agenda/modais/ObservacaoModal.vue'),
                }
            }
        ],
        meta: {
            title: "Registrar encontro",
        },
    },
    {
        path: '/cancelar/:id',
        name: 'cancel-meeting',
        component: () => import('@/views/Cancelar/Cancelar.vue'),
        meta: {
            title: "Cancelar encontro ",
        },
    },
    {
        path: '/reagendar/:id',
        name: 'reschedule',
        component: () => import('@/views/Reagendar/Reagendar.vue'),
        meta: {
            title: "Reagendar encontro",
        },
    },
    {
        path: '/minhas-organizacoes/',
        name: 'my-organizations',
        component: () => import('@/views/Organizacoes/Organizacoes.vue'),
        meta: {
            title: "",
        },
    },
    {
        path: '/error',
        name: 'error',
        component: () => import('@/defaultScreen/ErrorScreen.vue'),
        meta: {
            layout: "no-header",
            public: true
        },
    },
    {
        path: '/offline',
        name: 'offline',
        component: () => import("@/defaultScreen/OfflineScreen.vue"),
        meta: {
            layout: "no-header",
            public: true
        },
    },
    {
        path: '/relato-sucesso',
        name: 'report-success',
        component: () => import('@/defaultScreen/ReportSuccessScreen.vue'),
        meta: {
            layout: "no-header",
            public: false
        },
    },
    {
        path: '/sale-screen',
        name: 'sale-screen',
        component: () => import('@/defaultScreen/SaleScreen/SaleScreen.vue'),
        meta: {
            layout: "no-header",
            public: true
        },
    }
]

export default routes;
